import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
import { BaseCard } from "@cinch-nx/shared-ui";
import { useRouter } from "next/router";
import { Skeleton } from "@mui/material";
import { usePrefersReducedMotion } from "@cinch-nx/shared-ui";
import styles from "./header.module.css";
export var ArticleHeader = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, video = param.video;
    var isFallback = useRouter().isFallback;
    var prefersReducedMotion = usePrefersReducedMotion();
    if (isFallback) {
        return /*#__PURE__*/ _jsxs("header", {
            className: styles["header"],
            children: [
                /*#__PURE__*/ _jsx(Skeleton, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 250,
                    height: 61
                }),
                /*#__PURE__*/ _jsx(Skeleton, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 750,
                    height: 56
                })
            ]
        });
    }
    var ref;
    return /*#__PURE__*/ _jsxs("header", {
        className: styles["header"],
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles["title"],
                "data-testid": "article-title",
                children: title
            }),
            subTitle && /*#__PURE__*/ _jsx("p", {
                className: styles["subTitle"],
                children: subTitle
            }),
            ((ref = video === null || video === void 0 ? void 0 : video.length) !== null && ref !== void 0 ? ref : 0) <= 0 && (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ _jsx(BaseCard, {
                className: styles["imageWrapper"],
                children: /*#__PURE__*/ _jsx("img", {
                    src: getStoryblokImageServiceUrl(image.filename, {
                        height: 639,
                        width: 960,
                        filters: [
                            {
                                quality: 80
                            }
                        ],
                        fitIn: {
                            width: 960,
                            height: 639
                        }
                    }),
                    alt: image.alt || "article hero"
                })
            }) : null
        ]
    });
};
